import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import { NumberInput } from "../Form/NumberInput";
import ActionModal from "../global/ActionModal";
import { useCart } from "../../context/cart-context";

import { ReactComponent as PlusIcon } from "../../static/svg/plus.svg";
import { ReactComponent as MinusIcon } from "../../static/svg/minus.svg";
import { ReactComponent as Delete } from "../../static/svg/bin.svg";

export default function CheckoutCartCard({ data }) {
  // Initialize the value state with the current quantity from cart
  const [value, setValue] = React.useState(data.quantity || 0);
  const [ID, setID] = React.useState(0);
  const [show, setShow] = React.useState(false);

  // console.log("cart", cart);
  return (
    <React.Fragment>
      {/* Web & Tab */}

      <Card className="p-6 hidden md:flex ">
        <CardMedia
          component="img"
          sx={{ width: 100, height: 100 }}
          image={data.imgSrc}
          alt={data.name}
          // className=""
        />
        <Box sx={{ display: "flex" }} className="  w-full">
          <CardContent sx={{ flex: "1 0 auto" }} className="w-[40%]">
            <Typography
              component="div"
              variant="h3"
              fontWeight={400}
              color={"primary"}
              className=" line-clamp-2 w-full"
            >
              {data.name}
            </Typography>
            <Typography variant="subtitle" color="primary" component="div">
              £{data.price}
            </Typography>
          </CardContent>
          <Box
            sx={{ display: "flex" }}
            className=" items-center h-fit md:gap-4 lg:gap-12  place-content-end md:mr-4"
          >
            <Typography variant="subtitle" color="primary" component="div">
              £{(data.price * data.quantity).toFixed(2)}
            </Typography>

            <Typography variant="subtitle" color="primary" component="div">
              {data.quantity}
            </Typography>
          </Box>
        </Box>
      </Card>

      {/* Mobile */}

      <Card className="p-6 md:hidden flex ">
        <CardMedia
          component="img"
          sx={{ width: 180, height: 180 }}
          image={data.imgSrc}
          alt={data.name}
          // className=""
        />
        <Box className="w-full">
          <CardContent>
            <Typography
              component="div"
              variant="h3"
              fontWeight={400}
              color="primary"
              className=" line-clamp-2 "
            >
              {data.name}
            </Typography>
            <Typography variant="subtitle" color="primary" component="div">
              £{data.price}
            </Typography>
          </CardContent>

          <Box className="flex place-content-between items-center w-full ml-4">
            <Typography variant="subtitle" color="primary" component="div">
              £{(data.price * data.quantity).toFixed(2)}
            </Typography>

            <IconButton
              aria-label="delete"
              onClick={() => {
                // handleDelete(product.id);
                setID(data.id);
                setShow(true);
              }}
              color="primary"
              className="pl-8"
            >
              <Delete />
            </IconButton>
          </Box>
        </Box>
      </Card>
    </React.Fragment>
  );
}
